import middlewares from "./middlewares";
import { combinedReducers } from "../reducer";
import { compose, createStore } from "redux";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: Function;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancers = composeEnhancers(middlewares);

const getStore = () => createStore(combinedReducers, enhancers);

export default getStore();
